<template>
  <div class="screen">
    <div v-if="checkStep == 0" class="padmode">
      <el-card shadow="always" class="screenHead">
        <div style="font-size: 60px; margin-bottom: 10px">自主签到</div>
      </el-card>
      <div style="margin-top: 5%">
        <el-form>
          <el-form-item><el-input v-model="username" placeholder="请输入用户名" /></el-form-item>
          <el-form-item><el-input v-model="password" show-password placeholder="请输入密码" /></el-form-item>
          <el-form-item><el-button type="primary" style="width: 100%" @click="onLoad">登录</el-button></el-form-item>
        </el-form>
      </div>
    </div>
    <div v-else-if="checkStep == 1" class="padmode">
      <el-card shadow="always" class="screenHead">
        <div style="font-size: 60px; margin-bottom: 10px">自主签到</div>
      </el-card>
      <el-select v-model="signMatch" placeholder="请选择比赛" style="width: 100%" @change="getPlaceList">
        <el-option v-for="item in matchList" :key="item.id" :label="item.matchName" :value="item.id" />
      </el-select>
      <div style="margin: 20px 0"></div>
      <el-select v-model="signPlace" placeholder="请选择比赛场次" style="width: 100%">
        <el-option v-for="item in placeList" :key="item.id" :label="item.place" :value="item.id"> </el-option>
      </el-select>
      <div style="margin: 20px 0"><el-button size="medium" type="primary" @click="checkPlace" style="width: 100%">确认</el-button></div>
    </div>
    <div v-else>
      <el-input class="inputscan" v-model="idNo" autofocus ref="searchBox" @keyup.enter.native="showList"></el-input>
      <div v-show="signFlag">
        <img class="headImg" :src="backPic" @click="getfocus"/>
        <!-- <div style="margin: 20px 0"></div>
        <el-button type="primary" style="width: 100%" @click="showList">确认</el-button> -->
      </div>
      <div v-show="!signFlag" class="padmode">
        <div v-if="list.length === 0">
          <el-empty :image-size="400">
            <template #description>
    <div class="empty-desc">本场次暂无可签到项目</div>
  </template>
          </el-empty>
        </div>
        <div v-else>
          <!-- <el-card shadow="always" v-for="item in list" :key="item.id">
            <div style="margin-bottom: 20px"><span style="font-size: 50px; color: #ff0000">选手信息</span></div>
            <div class="onlive_txt">姓名：{{ item.childName }}</div>
            <div class="onlive_txt">展演组别：{{ item.team }}</div>
            <div class="onlive_txt">展演项目：{{ item.item2 }}</div>
          </el-card> -->
          <div style="margin-top:5%;margin-bottom: 160px"><span style="font-size: 150px; color: #ff0000">签到成功</span></div>
          <el-table :data="list" border style="width: 100%" class="custom-table" :header-cell-style="{ background: '#409EFF', color: '#fff' }">
            <el-table-column prop="childName" label="姓名" align="center"> </el-table-column>
            <el-table-column prop="team" label="展演组别" align="center"> </el-table-column>
            <el-table-column prop="item2" label="展演项目" align="center"> </el-table-column>
          </el-table>
        </div>
        <div style="margin: 160px 0"></div>
        <p style="font-size:80px;color:#909399">{{count}}秒后返回</p>
        <!-- 
        <el-button type="success" style="width: 100%" @click="getback">确认</el-button> -->
      </div>
    </div>
  </div>
</template>

<script>
import enrollApi from '../api/enroll.js'
import matchApi from '../api/match.js'

export default {
  data() {
    return {
      checkStep: 0,
      username: '',
      password: '',
      idNo: '',
      matchList: {},
      placeList: {},
      signPlace: [],
      signMatch: [],
      signFlag: true,
      child: { childName: '', team: '', workName: '' },
      backPic: '',
      list: [],
      timer: '',
      tag:1,
      readonly: false,
      count: 5,
      fiveover: true
    }
  },
  methods: {
    getfocus(){
      this.$nextTick(() => {
        this.$refs.searchBox.focus()
      })
    },
    onLoad() {
      if (this.password === '123456') {
        this.checkStep = 1
      } else {
        this.$message.error('密码错误')
      }
    },
    showList() {
      this.readonly = true
      if (this.idNo == '' || !this.fiveover) {
        return
      }
      this.signFlag = false
      this.list = []
      // 倒计时5s跳回
      enrollApi.getSignListByChildAndPlace(this.idNo, this.signPlace).then((res) => {
        if (res.data.success) {
          this.list = res.data.data.list
        }
        // this.timer = setInterval(this.getback, 5000)
      })
      this.timer = setInterval(() => {
        this.fiveover = false
        this.count--;
        if (this.count <= 0) {
          clearInterval(this.timer);
          this.getback(); // 倒计时结束触发返回
        }
      }, 1000);
    },
    getMatch() {
      matchApi.matchSignList().then((res) => {
        if (res.data.success) {
          this.matchList = res.data.data.list
        }
      })
    },
    getPlaceList(item) {
      this.signPlace = null
      enrollApi.getSignPlace(item).then((res) => {
        if (res.data.success) {
          this.placeList = res.data.data.list
        }
      })
    },
    getback() {
      this.count = 5
      this.fiveover = true
      this.signFlag = true
      this.idNo = ''
      clearInterval(this.timer)
      // this.$nextTick(() => {
      //   window.scrollTo(0, document.body.scrollHeight); // 滚动到页面底部
      // });
      // this.readonly = true
      this.$nextTick(() => {
        this.$refs.searchBox.focus()
      })
    },
    checkPlace() {
      this.signFlag = true
      if (this.signPlace != '') {
        this.checkStep = 2
        // 根据no把头部背景图片查找出来
        enrollApi.getBackPic(this.signPlace).then((res) => {
          this.backPic = res.data.data.backPic
          document.documentElement.requestFullscreen()
        })
      }
    }
  },
  mounted() {
    this.getMatch.call(this)
  }
}
</script>
<style scoped>
.el-table {
  font-size: 80px;
}
::v-deep .el-table .cell {
  height: 120px;
  vertical-align: middle;
  line-height: 120px;
}
.screen {
  margin: 0 auto; 
}
.padmode{
  padding: 30px 50px;
}
.screenHead {
  margin-bottom: 20px;
  background-image: url(../assets/11.jpg);
  color: #fff;
}
.headImg {
  width: 100%;
  border-radius: 5px;
}
input:focus {
  opacity: 0; /* 或 visibility: hidden; */
}
.inputscan {
  height: 1px;
}
>>> .inputscan .el-input__inner {
  line-height: 1px;
  height: 1px !important;
}
.empty-desc{
  font-size: 60px;
}
</style>
